export default __webpack_public_path__ + "static/media/ssnap.58a0656f.png";